// src/features/auth/axiosConfig.ts
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});
export const IS_STANDALONE = process.env.REACT_APP_STANDALONE === "true";
export const reactAppVersion = process.env.REACT_APP_VERSION;

//image base URL
export const imageBaseURL = process.env.REACT_APP_IMAGE_PATH;

// Request Interceptor
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("jsonwebtoken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error("Request Setup Error:", error);
    return Promise.reject(error);
  },
);

// Response Interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error("Response Error:", error.message);
    if (error.message === "Request failed with status code 401") {
      if (sessionStorage.getItem("jsonwebtoken")) {
        window.location.href = "/pos";
      }
      sessionStorage.removeItem("jsonwebtoken");
    }
    return Promise.reject(error);
  },
);

export default api;
